import { HelperCore } from '@/common/helper';
import { getSpeechToken } from '@/services/speech';
import { makeAutoObservable } from 'mobx';

class SpeechToTextStore {
  #config = null;

  constructor() {
    makeAutoObservable(this);

    if (!HelperCore.IS_PROD) {
      window._speechToTextStore = this;
    }
  }

  getConfig = async () => {
    if (this.#config === null) {
      const { code, data, msg } = await getSpeechToken();
      // const { code, data, msg } = {
      //   code: 0,
      //   msg: 'ok',
      //   timestamp: 1707383291,
      //   data: {
      //     speech_key: 'b301e554220b49ec8b658e0a9e6f7ba2',
      //     speech_region: 'eastasia',
      //   },
      // };
      if (code == 0) {
        this.#config = {
          subscriptionKey: data.speech_key,
          region: data.speech_region,
        };
      }
    }
    return this.#config;
  };
}

const speechToTextStore = new SpeechToTextStore();
export default speechToTextStore;
